import { useEffect, useState } from "react";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import iconFor from "@/components/site/iconMap";
import SafeHtml from "@/components/site/SafeHtml";
import api from "@/lib/api";

// Shared alternating detail layout for Solutions & Services
export default function DetailListPage({ collection, eyebrow, title, subtitle, heroImage }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} | Labpronics Technologies`;
    api.get(`/content/${collection}`).then((r) => setItems(r.data)).catch(() => {});
  }, [collection, title]);

  return (
    <Layout>
      <PageHero eyebrow={eyebrow} title={title} subtitle={subtitle} image={heroImage} />
      <section className="py-20">
        <div className="container-lp space-y-20">
          {items.map((s, i) => {
            const Icon = iconFor(s.icon);
            const flip = i % 2 === 1;
            return (
              <Reveal key={s.id}>
                <div className="grid lg:grid-cols-12 gap-10 items-center">
                  <div className={`lg:col-span-6 ${flip ? "lg:order-2" : ""}`}>
                    <div className="img-zoom clip-frame border border-lp-border">
                      <img src={s.image} alt={s.title} loading="lazy" className="w-full h-[360px] object-cover" />
                    </div>
                  </div>
                  <div className={`lg:col-span-6 ${flip ? "lg:order-1" : ""}`}>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="h-11 w-11 bg-lp-grey rounded-sm flex items-center justify-center"><Icon size={22} className="text-lp-blue" /></div>
                      <span className="eyebrow">{String(i + 1).padStart(2, "0")}</span>
                    </div>
                    <h2 className="font-heading font-700 text-lp-blue text-2xl md:text-3xl tracking-tight">{s.title}</h2>
                    <p className="mt-4 text-lp-muted leading-relaxed">{s.excerpt}</p>
                    {s.content && <SafeHtml className="prose-lp mt-4" html={s.content} />}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </Layout>
  );
}
